function prepareDonorName(donor) {
  if (!donor) {
    return ''
  }
  if (donor.fullName) {
    return donor.fullName
  } else if (donor.firstName || donor.lastName) {
    return ((donor.firstName ?? '').trim() + ' ' + (donor.lastName ?? '').trim()).trim()
  } else if (donor.first_name || donor.last_name) {
    return ((donor.first_name ?? '').trim() + ' ' + (donor.last_name ?? '').trim()).trim()
  } else if (donor.fname || donor.lname) {
    return (donor.fname ? donor.fname + ' ' : '') + (donor.lname ? donor.lname : '')
  } else {
    return ''
  }
}

function filterDonorById(id, donors) {
  id = parseInt(id);
  for (let i = 0; i < donors.length; i++) {
    if(parseInt(donors[i].id) === id){
      return donors[i];
    }
  }
  return null;
}

function prepareDonorsArray(rData) {

  const incomplete = rData.incomplete.map(v => {
    v.status = 'incomplete';
    return v;
  });
  const complete = rData.complete.map(v => {
    v.status = 'complete';
    return v;
  });
  const no_funding = rData.no_funding.map(v => {
    v.status = 'n/a';
    return v;
  });
  const no_ru = rData.no_ru.map(v => {
    v.status = 'n/a';
    return v;
  });

  return [...incomplete, ...complete, ...no_funding, ...no_ru].map(v => {
    v['name'] = prepareDonorName(v);
    v['short_name'] = (v.fname ? v.fname[0] : '') + (v.lname ? v.lname[0] : '');
    v['total'] = null;
    if (v.roundup_donation_total !== null || v.custom_donation_total !== null) {
      v['total'] = v.donation_total * 1;
    }
    v['monthly_donations'] = null;
    if (v.custom_donation_total !== null || v.donation_total !== null) {
      v['monthly_donations'] = v.donation_total * 1 - v.custom_donation_total * 1 - v.roundup_donation_total * 1;
    }
    return v;
  });
}

export {prepareDonorsArray, prepareDonorName, filterDonorById};